import { createContext, useContext, useState, useEffect } from 'react';

const MobileContext = createContext({});

const SIDEBAR_COLLAPSED_KEY = 'bizcore.sidebar_collapsed';

export function MobileProvider({ children }) {
  const [isMobile, setIsMobile] = useState(false);
  const [sidebarOpen, setSidebarOpen] = useState(false);
  // Persist desktop "collapsed" state so it survives reloads.
  const [sidebarCollapsed, setSidebarCollapsed] = useState(() => {
    try { return localStorage.getItem(SIDEBAR_COLLAPSED_KEY) === '1'; }
    catch { return false; }
  });

  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth < 1024);
      if (window.innerWidth >= 1024) {
        setSidebarOpen(false);
      }
    };
    
    checkMobile();
    window.addEventListener('resize', checkMobile);
    return () => window.removeEventListener('resize', checkMobile);
  }, []);

  // Persist collapsed state
  useEffect(() => {
    try { localStorage.setItem(SIDEBAR_COLLAPSED_KEY, sidebarCollapsed ? '1' : '0'); }
    catch { /* storage disabled */ }
  }, [sidebarCollapsed]);

  const toggleSidebar = () => setSidebarOpen(!sidebarOpen);
  const closeSidebar = () => setSidebarOpen(false);
  const toggleSidebarCollapsed = () => setSidebarCollapsed(c => !c);

  return (
    <MobileContext.Provider
      value={{
        isMobile,
        sidebarOpen,
        toggleSidebar,
        closeSidebar,
        sidebarCollapsed,
        toggleSidebarCollapsed,
        setSidebarCollapsed,
      }}
    >
      {children}
    </MobileContext.Provider>
  );
}

export function useMobile() {
  return useContext(MobileContext);
}
